import { render, staticRenderFns } from "./PlateEditDialog.vue?vue&type=template&id=2537d93f&scoped=true&"
import script from "./PlateEditDialog.vue?vue&type=script&lang=js&"
export * from "./PlateEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./PlateEditDialog.vue?vue&type=style&index=0&id=2537d93f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2537d93f",
  null
  
)

export default component.exports